import { render, staticRenderFns } from "./organizationGroupAction.vue?vue&type=template&id=375647e2&scoped=true"
import script from "./organizationGroupAction.vue?vue&type=script&lang=js"
export * from "./organizationGroupAction.vue?vue&type=script&lang=js"
import style0 from "./organizationGroupAction.vue?vue&type=style&index=0&id=375647e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375647e2",
  null
  
)

export default component.exports